<template>
  <el-dialog v-loading="loading" class="online_model_dialog" top="5vh" center
    :title="'【' + formInfo.taskInfo.pid + '.' + formInfo.taskInfo.id + '】' + '已上线'" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="form" size="mini" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          {{ allSelect.TEXTDOMAINS[form.domain] }}
        </el-form-item>
        <el-form-item label="系统" label-width="65px">
          {{ allSelect.TEXTMODULES[form.module] }}
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item label="产品" :label-width="formLabelWidth">
          {{ allSelect.TEXTUSERS[form.user_pm] }}
        </el-form-item>
        <el-form-item label="开发" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_rd] }}
        </el-form-item>
        <el-form-item label="测试" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_qa] }}
        </el-form-item>
        <el-form-item label="技术评审员" label-width="100px">
          {{ techReviewerCh }}
        </el-form-item>
      </div>
      <el-form-item label="代码分支" :label-width="formLabelWidth">
        <div style="text-decoration: underline;color: #409EFF;cursor: pointer;" @click="openLink(form.branch_web_url_prefix + form.branch)">
          {{ form.branch }}
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
} from "@/server/tops/devOps";

import { mapState } from "vuex";
export default {
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        domain: "",
      },
      rules: {},
      formLabelWidth: "130px",
      loading: true
    };
  },
  async created() {
    const {
      user_pm,
      user_qa,
      module = "",
      user_rd,
      id = "",
      pid = "",
      tech_reviewer = "",
      domain = '',
    } = this.formInfo?.taskInfo || {};
    this.form = { ...this.form, id, pid, user_pm, user_qa, module, user_rd, tech_reviewer, domain };
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
    techReviewerCh() {
      let names = '';
      this.form.tech_reviewer.split(",").forEach((item) => {
        if (this.allSelect.TEXTUSERS[item]) {
          names += this.allSelect.TEXTUSERS[item] + ' '
        }
      })
      return names;
    }
  },
  methods: {
    // 获取开发中任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      try {
        const { id = "", pid = "" } = this.formInfo?.taskInfo || {};
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id: "15",// 21
          task_id: id,
          pid,
        });
        if (ret.status === "success") {
          const { common_branch: branch, branch_web_url_prefix = '' } = ret.data || {};
          this.form = {
            ...this.form,
            branch,
            branch_web_url_prefix
          };
        } else {
          this.$notify({
            message: ret.error || "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading = false
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    // 打开外链接
    openLink(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="scss">
.online_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
</style>